/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from './moe-tile-list-item-description-only';
import { BiRightArrowAlt } from 'react-icons/bi';

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps): JSX.Element => {
    const { heading, paragraph, tileListContainer, tileListHeadingContainer } = props;

    return (
        <div tabIndex={0} className='moe-tile-desc-only-container'>
            <Node {...tileListContainer}>
                <Node {...tileListHeadingContainer}>
                    {heading}
                    {paragraph}
                    <span className='ms-tile-text-arrow'>
                        <BiRightArrowAlt size={25}></BiRightArrowAlt>
                    </span>
                </Node>
                <div className='ms-tile-bottom'></div>
            </Node>
        </div>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps> = props => {
    const { tileListItem } = props;
    return <Module {...tileListItem}>{renderTileListItemContent(props)}</Module>;
};

export default TileListItemViewComponent;
